import React from "react";
import Sidebar from "./Sidebar";
import Topbar from "./Topbar";

export default function AppShell({ title, subtitle, actions, children }) {
    return (
        <div className="min-h-screen bg-background">
            <Sidebar />
            <div className="md:pl-64">
                <Topbar title={title} subtitle={subtitle} actions={actions} />
                <main className="px-6 py-6 max-w-[1600px] mx-auto">{children}</main>
            </div>
        </div>
    );
}
